<template>
    <div>
        <div
            ref="KCTabs"
        >
            <BTabs
                data-cy="KCTabs"
                :class="variantClass"
                @input="setNewSelection(items[$event], 'KCTabs')"
            >
                <BTab
                    v-for="(tab, tabIndex) in items"
                    :key="tabIndex"
                    :disabled="disabled"
                    :active="currentSelection.value && currentSelection.value === tab.value"
                    :value="tab.value"
                >
                    <template #title>
                        <div
                            class="tab-icon d-inline-block"
                        />
                        {{ tab.text }}
                    </template>
                </BTab>
            </BTabs>
        </div>
        <div
            ref="KCTabsDropdown"
            class="kct-dropdown"
        >
            <Dropdown
                :id="id"
                data-cy="KCTabsDropdown"
                :options="items"
                :disabled="disabled"
                :selection="[currentSelection]"
                @kc::dropdown::selection="setNewSelection($event[0], 'KCTabsDropdown')"
            />
        </div>
    </div>
</template>

<script>
    import uniqueId from 'lodash/uniqueId';

    import Dropdown from './Dropdown.vue';

    /**
     * @group Content
     * A component to utilize a Kit Car KCTabs component.
     */
    export default {
        name: 'KCTabs',
        components: {
            Dropdown,
        },
        props: {
            /**
             * Disables clicking on both tabs and dropdown component
             */
            disabled: {
                type: Boolean,
                default: false
            },
            /**
             * Initial text/value object that should be set on load
             */
            initialValue: {
                type: Object,
                default: null,
            },
            /**
             * Items to populate menus
             */
            items: {
                type: [Array, Object],
                required: true,
            },
            /**
             * Input class for tab styling
             */
            variant: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                currentSelection: this.initialValue ? this.initialValue : this.items[0],
            };
        },
        computed: {
            id() {
                return `kct-${uniqueId()}`;
            },
            variantClass() {
                return this.variant !== '' ? `kc-tabs-${this.variant}` : 'kc-tabs';
            },
        },
        mounted() {
            this.handleResizeWindow();
            window.addEventListener('resize', this.handleResizeWindow);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResizeWindow);
        },
        methods: {
            handleResizeWindow() {
                this.$refs.KCTabs.style.display = (window.innerWidth < 768) ? 'none' : 'unset';
                this.$refs.KCTabsDropdown.style.display = (window.innerWidth > 768) ? 'none' : 'unset';
            },
            setNewSelection(newSelection, ref) {
                const elementActive = this.$refs[ref].style.display !== 'none';

                if (elementActive && this.currentSelection !== newSelection) {
                    this.currentSelection = newSelection;
                    this.$emit('tabs-changed', newSelection.value);
                }
            }
        }
    };
</script>
